import { createApi } from '@reduxjs/toolkit/query/react';

import { tagTypes } from './api-tags';
import { baseQueryWithReauth } from './base-query';

/**
 * Root RTK Query API instance.
 * Feature modules inject endpoints via injectEndpoints() for code-splitting.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes,
  endpoints: () => ({}),
  keepUnusedDataFor: 60,
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
});
